interface ReleaseSelection { releaseId: string; channel: 'production' | 'preview' }

let audienceGeneration = 0

export function selectedRelease(): ReleaseSelection | null {
  const releaseId = document.querySelector<HTMLMetaElement>('meta[name="ielts-release-id"]')?.content
  const channel = document.querySelector<HTMLMetaElement>('meta[name="ielts-release-channel"]')?.content
  return releaseId && /^[a-z0-9-]+$/.test(releaseId) && (channel === 'production' || channel === 'preview')
    ? { releaseId, channel } : null
}

export function setReleaseAudience(audience: 'admin' | 'student' | 'public') {
  // An opt-out hint for mixed staff/student sessions. The server still checks
  // signed employee cookies and current account status before allowing preview.
  document.cookie = `ielts_release_audience=${audience}; Path=/; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`
  return ++audienceGeneration
}

export async function reconcileRelease(generation = audienceGeneration) {
  const current = selectedRelease()
  if (!current) return // Vite development and deployments before the router.
  try {
    const response = await fetch('/__release/status', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(5000) })
    if (!response.ok || generation !== audienceGeneration) return
    const next: ReleaseSelection = await response.json()
    if (generation !== audienceGeneration || typeof next.releaseId !== 'string' || !/^[a-z0-9-]+$/.test(next.releaseId)
      || !['production', 'preview'].includes(next.channel)) return
    if (next.releaseId !== current.releaseId || next.channel !== current.channel) location.reload()
  } catch { /* Keep the currently loaded app usable if release discovery fails. */ }
}
